import { h } from 'preact';

const Loading = (props) => (
    <div class="spinner-box">
        <div class="psoload">
            <div class="straight"></div>
            <div class="curve"></div>
            <div class="center"></div>
            <div class="inner"></div>
        </div>
    </div>
) 

export default Loading